import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsFlightTable from './addons-flight';
import GuestFlightTable from './guest-flight';

interface Props {
  refund?: RefundModel;
}

export default function FlightPurchaseSection(props: Props) {
  const { control } = useFormContext();
  const name = 'flightPurchases';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      {fields.map((field, index) => {
        return (
          <Separator key={field.customId} gap={24} direction="vertical">
            <CardSection key={field.customId}>
              <FullContainer>
                <SectionContainer>
                  <Text variant="body1Bold">
                    {t('ticketSales:schedule_extra', {
                      extra: index + 1,
                    })}
                  </Text>
                  <Input
                    type="text"
                    name={`flightPurchases.${index}.bookingCode`}
                    label={t('common:booking_code')}
                    labelPlacement={TextLabelPlacementEnum.Left}
                    placeholder={t('common:booking_code')}
                    noMargin
                    disabled
                  />
                </SectionContainer>
                <Separator gap={24} />
                <GuestFlightTable parentIndex={index} refund={props.refund} />
                <Separator gap={24} />
                <AddonsFlightTable parentIndex={index} refund={props.refund} />
                <Separator gap={24} />
              </FullContainer>
            </CardSection>
          </Separator>
        );
      })}
    </>
  );
}
